import { CaType, CaActivity, CeActivity, ProcedureType, ContractType, LotSubmission, AcType } from './ojeu.notice.enums';

export class OjeuAddressDto {
    line1: string;
    town: string;
    postcode: string;
    country: string;
}

export abstract class OjeuContactDto {
    officialName: string;
    email: string;
    phone: string;
    fax: string;
    nutsCode: string;
    generalUrl: string;
    address: OjeuAddressDto;
    noticeId: string;
    nationalId: string;

    protected constructor() {
        this.address = new OjeuAddressDto();
    }
}

export class HvtSection1Dto {
    isJointProcurement: boolean;
    procurementLaw: string;
    documentUrl: string;
    participationUrl: string;
    caType: CaType;
    caTypeOther: string;
    caActivity: CaActivity;
    caActivityOther: string;
    ceActivity: CeActivity;
    ceActivityOther: string;
    procurementLawApplicable: boolean;
    isCentralPurchasing: boolean;
    fullDocumentAvailable: boolean;
    documentRestricted: boolean;
    toolUrl: string;
    furtherInfoAddressIdem: boolean;
    participationAddressIdem: boolean;
    contacts: HvtSection1ContactDto[];

    furtherInfoSpecificAddress: boolean;
    furtherInfoAddress: HvtSection1ContactDto;

    participationSpecificAddress: boolean;
    participationAddress: HvtSection1ContactDto;

    constructor() {
        this.contacts = [];
    }
}

export class HvtSection1ContactDto extends OjeuContactDto {
    id: number;
    isPrimaryContact: boolean;
    isParticipationContact: boolean;
    isFurtherInfoContact: boolean;
    contactPoint: string;
    buyerUrl: string;

    constructor() {
        super();
    }
}

export class HvtSection2Dto {
    objectContracts: ObjectContractDto[];
    isContractAward: boolean;

    constructor() {
        this.objectContracts = [];
    }
}

export class ObjectContractDto {
    id: number;
    title: string;
    refNumber: string;
    cpvMain: string;
    supplementaryCpvs: CodeDto[];
    contractType: ContractType;
    description: string;
    estimatedValue: boolean;
    value?: number;
    maxValue?: number;
    minValue?: number;
    agreedToPublish?: boolean;
    currency: string;
    submissionType: LotSubmission;
    maxSubmissionLots: string;
    maxLotsToOneTenderer: string;
    lotCombiningRight: string;
    jsPublicationNoticeDate: string;
    lots: LotDto[];

    constructor() {
        this.lots = [];
        this.supplementaryCpvs = [];
    }
}

export class LotDto {
    id: number;
    itemId: number;
    title: string;
    lotNumber: string;
    nutsCodes: CodeDto[];
    mainSite: string;
    description: string;
    acInProcurementDocs: boolean;
    value?: number;
    maxValue: string;
    minValue: string;
    currency: string;
    duration: number;
    durationUnits: string;
    jsStartDate: string;
    jsEndDate: string;
    renewal: boolean;
    renewalDescription: string;
    envisagedCandidates?: number;
    envisagedMinCandidates?: number;
    envisagedMaxCandidates?: number;
    candidateCriteria: string;
    variantsAccepted: boolean;
    hasOptions: boolean;
    optionsDescription: string;
    relatedEuProgram: boolean;
    euProgramRelated: string;
    eCatalogueRequired: boolean;
    additionalInformation: string;
    eu201424Directive: boolean;
    eu201423Directive: boolean;
    ec200981Directive: boolean;
    projectIdentification: string;
    additionalCpvs: CodeDto[];
    acceptanceCriteria: AcceptanceCriterionDto[];

    constructor() {
        this.nutsCodes = [];
        this.additionalCpvs = [];
        this.acceptanceCriteria = [];
    }
}

export class CodeDto {
    id: number;
    code: string;
}

export class AcceptanceCriterionDto {
    id: number;
    name: string;
    type: AcType;
    weighting: string;
}

export class HvtSection3Dto {
    isBlank: boolean;
    suitability: string;
    rulesCriteria: string;
    performanceConditions: string;
    restrictedShelteredWorkshop: boolean;
    restrictedShelteredProgram: boolean;
    depositGuarantee: string;
    mainFinancingCondition: string;
    legalForm: string;
    particularProfession: boolean;
    referenceToLaw: string;
    performanceStaffQualification: boolean;
    economicInfo: EconomicInfoDto;
    technicalInfo: TechnicalInfoDto;

    constructor() {
        this.economicInfo = new EconomicInfoDto();
        this.technicalInfo = new TechnicalInfoDto();
    }
}

export class EconomicInfoDto {
    main: string;
    minimum: string;
    inDocs: boolean;
}

export class TechnicalInfoDto {
    main: string;
    minimum: string;
    inDocs: boolean;
}

export class HvtSection4Dto {
    types: TypeDetailDto[];
    acceleratedDetails: string;
    jsTenderReceiptDate;
    tenderReceiptTime: string;
    duration: string;
    coveredByGpa?: boolean;
    hasFramework: boolean;
    framework: FrameworkDto;
    hasOpeningCondition: boolean;
    openingCondition: OpeningConditionDto;
    jsInvitationDispatchDate: string;
    dynamicPurchaseSystem: boolean;
    additionalDynamicPurchasers: boolean;
    eAuction: boolean;
    eAuctionAdditionalInformation: string;
    ec200981Directive: boolean;
    eu201423Directive: boolean;
    eu201424Directive: boolean;
    eu201425Directive: boolean;
    ojeuNoticeNumber: string;
    reductionRecourse: boolean;
    rightToContractInitialTenderers: boolean;
    jsTenderValidDate: string;
    dpsTermination: boolean;
    pinTermination: boolean;
    jsAwardScheduledDate: string;
    dOutsideScope: boolean;
    dJustification: string;
    dTechnical: boolean;
    dArtistic: boolean;
    dProtectRights: boolean;

    dExtremeUrgency: boolean;
    dAddDeliveriesOrdered: boolean;
    dRepetitionExisting: boolean;
    dContractAwardedDesignContest: boolean;
    dCommodityMarket: boolean;
    dFromWindingProvider: boolean;
    dFromLiquidatorCreditor: boolean;
    isAccelerated: boolean;

    dRepetitionExistingType: ContractType;
    dContractAwardedDesignContestType: ContractType;
    dManufacturedForResearchType: ContractType;
    nationalProcedureUrl: string;
    mainFeaturesAward: string;
    criteriaEvaluation: string;
    languages: HvtSection4LanguageDto[];
    isContractAward: boolean;

    constructor() {
        this.openingCondition = new OpeningConditionDto();
        this.languages = [];
    }
}

export class TypeDetailDto {
    type: ProcedureType;
    details: string;
}

export class FrameworkDto {
    isSingleOperator: boolean;
    hasSeveralOperators: boolean;
    participants: string;
    justification: string;
}

export class OpeningConditionDto {
    jsOpeningDate: string;
    openingTime: string;
    location: string;
    furtherInfo: string;
}

export class HvtSection4LanguageDto {
    id: number;
    name: string;
}

export class HvtSection5Dto {
    contractAwards: OjeuContractAwardDto[];

    constructor() {
        this.contractAwards = [];
    }
}

export class OjeuContractAwardDto {
    id: number;
    itemId: number;
    title: string;
    lotNumber: string;
    awarded: boolean;
    procurementUnsuccessful: boolean;
    procurementDiscontinued: boolean;
    jsContractConclusionDate: string;
    awardedToGroup: boolean;
    tendersReceived: number;
    tendersReceivedSme: number;
    tendersReceivedOtherEu: number;
    tendersReceivedNonEu: number;
    tendersReceivedEmeans: number;
    contractNumber: string;
    estimatedTotal: TenderValueDto;
    total: TenderValueDto;
    rangeTotal: TenderValueDto;
    likelySubcontracted: boolean;
    subcontractingValue: TenderValueDto;
    subcontractingProportion: string;
    additionalSubcontractingInfo: string;
    contractors: HvtSection5ContactDto[];
    agreeToPublishValue: boolean;
    bargainPurchaseValue: TenderValueDto;

    showDetails = true;

    constructor() {
        this.estimatedTotal = new TenderValueDto();
        this.total = new TenderValueDto();
        this.rangeTotal = new TenderValueDto();
        this.subcontractingValue = new TenderValueDto();

        this.contractors = [];
    }
}

export class TenderValueDto {
    value?: number;
    currency: string;
    maxValue?: number;
    minValue?: number;
}

export class HvtSection5ContactDto extends OjeuContactDto {
    id: number;
    sme: boolean;

    constructor() {
        super();
    }
}

export class HvtSection6Dto {
    isRecurring: boolean;
    estimatedTiming: string;
    additionalInfo: string;
    jsNoticeDispatchDate: string;
    reviewProcedure: string;
    electronicWorkflow: ElectronicWorkflowDto;
    reviewBodyAddress: HvtSection6ContactDto;
    mediationBodyAddress: HvtSection6ContactDto;
    reviewInfoAddress: HvtSection6ContactDto;
    contractorAddress: HvtSection6ContactDto;

    constructor() {
        this.electronicWorkflow = new ElectronicWorkflowDto();
        this.reviewBodyAddress = new HvtSection6ContactDto();
        this.mediationBodyAddress = new HvtSection6ContactDto();
        this.reviewInfoAddress = new HvtSection6ContactDto();
        this.contractorAddress = new HvtSection6ContactDto();
    }
}

export class ElectronicWorkflowDto {
    eOrdering: boolean;
    eInvoicing: boolean;
    ePayment: boolean;
}

export class HvtSection6ContactDto extends OjeuContactDto {
    constructor() {
        super();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/notices/ojeu.notice.models.ts